/** Shared CliQloan marketing tokens (aligned with website-cliqloan). */
export const CLIQLOAN_BRAND = {
  deepPurple: "#373973",
  cliqPurple: "#8b3dff",
  cliqTeal: "#31b9b5",
  cliqTealHover: "#2a9d99",
  accentInteractive: "#31b9b5",
  textDark: "#1f1f1f",
  textMuted: "#4C5270",
  textNavy: "#00357A",
  lightGray: "#edf0f2",
  footerPartnerBg: "#f3faf9",
  footerBorder: "#d8ebe9",
  blogCardImageBg: "#f0f8f7",
  pageBg: "#FCFCFC",
  white: "#ffffff",
  gradientPartner: "linear-gradient(90deg, #373973 0%, #8b3dff 100%)",
  gradientHero: "linear-gradient(135deg, #373973 0%, #4a4f9a 45%, rgba(49, 185, 181, 0.35) 100%)",
  maxContent: 1280,
  contactEmail: "support-cliqloan@amitasoft.com",
  contactPhone: "+1-408-430-3650",
};
